<template>
  <!-- 外面包一层div是为了方便控制层级关系，最后用完也需要把它销毁 -->
  <div class="background_wraper"
       v-if="toastState.click">
    <!-- 绑定一个全屏点击背景 并加入淡入淡出效果 -->
    <div :class="[
        this.toastState.click ? 'click_background_active' : 'click_background',
        this.toastState.fade ? 'fade_in_public' : 'fade_out_public'
      ]"
         @click="backgroundClickHandle"></div>
    <!-- 场景及设备控制界面的最外层 -->
    <div class="control_wrap"
         v-if="toastState.click"
         :class="toastState.fade ? 'fade_in_public' : 'fade_out_public'">
      <!-- 场景及设备控制的二级界面 -->
      <div v-if="type === 'scene'">
        <!-- 场景 -->
        <scene-toast :objData="objData"></scene-toast>
      </div>
      <div v-else-if="type === 'device'">
        <!-- 设备 -->
        <device027-socket-w1 v-if="deviceTypeJudge('027')"
                             :objData="objData"
                             :serve027ShowData="serve027ShowData"></device027-socket-w1>
        <!-- //代号 20231207-1 -->
        <device014-f-dimming v-else-if="deviceTypeJudge('014', '02','049')"
                             :objData="objData"></device014-f-dimming>
        <device08-a-aircond v-else-if="deviceTypeJudge('08', '016')"
                            :objData="objData"
                            :deviceTemp="deviceTemp"></device08-a-aircond>
        <device017-a-floorheating v-else-if="deviceTypeJudge('017')"
                                  :objData="objData"
                                  :deviceTemp="deviceTemp"></device017-a-floorheating>
        <device018-a-newtrend v-else-if="deviceTypeJudge('018')"
                              :objData="objData"
                              :deviceTemp="deviceTemp"></device018-a-newtrend>
        <device024-a-music v-else-if="deviceTypeJudge('024')"
                           :objData="objData"></device024-a-music>
        <device023-f-movies v-else-if="deviceTypeJudge('023')"
                            :objData="objData"
                            :serve023ShowData="serve023ShowData"></device023-f-movies>
        <device025-f-dimming2 v-else-if="deviceTypeJudge('025')"
                              :objData="objData"></device025-f-dimming2>
        <device026-f-dimming3 v-else-if="deviceTypeJudge('026')"
                              :objData="objData"></device026-f-dimming3>
        <device029-f-rgbw v-else-if="deviceTypeJudge('029')"
                          :objData="objData"></device029-f-rgbw>
        <device06-a-dianji v-else-if="deviceTypeJudge('06','010')"
                           :objData="objData"></device06-a-dianji>
        <device015-a0-dianji v-else-if="deviceTypeJudge('015')"
                             :objData="objData"></device015-a0-dianji>
        <device020-f-mianban v-else-if="deviceTypeJudge('020', '09', '03')"
                             :objData="objData"></device020-f-mianban>
        <device07-mensuo v-else-if="deviceTypeJudge('07')"
                         :objData="objData"></device07-mensuo>
        <device013-security v-else-if="deviceTypeJudge('013')"
                            :objData="objData"></device013-security>
        <device022-a-timing v-else-if="deviceTypeJudge('022')"
                            :objData="objData"
                            :ServeOneObjectinfo="ServeOneObjectinfo"></device022-a-timing>
        <device019-envprobe v-else-if="deviceTypeJudge('019')"
                            :objData="objData"
                            :ServeOneObjectinfo="ServeOneObjectinfo"
                            :serveShowData="serve019ShowData"
                            :position="location019"></device019-envprobe>
        <div v-else>暂时不支持此设备的控制，请升级软件版本或联系技术人员，谢谢您的支持和理解。</div>
      </div>
      <div v-else-if="type === 'config'">
        <config027-socket-w1 v-if="deviceTypeJudge('027')"
                             :objData="objData"></config027-socket-w1>
        <config014-f-dimming v-else-if="deviceTypeJudge('014', '02')"
                             :objData="objData"></config014-f-dimming>
        <config08-a-aircond v-else-if="deviceTypeJudge('08', '016')"
                            :objData="objData"></config08-a-aircond>
        <config017-a-floorheating v-else-if="deviceTypeJudge('017')"
                                  :objData="objData"></config017-a-floorheating>
        <config018-a-newtrend v-else-if="deviceTypeJudge('018')"
                              :objData="objData"></config018-a-newtrend>
        <config024-a-music v-else-if="deviceTypeJudge('024')"
                           :objData="objData"></config024-a-music>
        <config023-f-movies v-else-if="deviceTypeJudge('023')"
                            :objData="objData"
                            :serve023ShowData="serve023ShowData"></config023-f-movies>
        <config025-f-dimming2 v-else-if="deviceTypeJudge('025')"
                              :objData="objData"></config025-f-dimming2>
        <config026-f-dimming3 v-else-if="deviceTypeJudge('026')"
                              :objData="objData"></config026-f-dimming3>
        <config029-f-rgbw v-else-if="deviceTypeJudge('029')"
                          :objData="objData"></config029-f-rgbw>
        <!-- 代号20200731-1 -->
        <config06-a-dianji v-else-if="deviceTypeJudge('06','010')"
                           :objData="objData"></config06-a-dianji>
        <config015-a0-dianji v-else-if="deviceTypeJudge('015')"
                             :objData="objData"></config015-a0-dianji>
        <config020-f-mianban v-else-if="deviceTypeJudge('020', '09', '03')"
                             :objData="objData"></config020-f-mianban>
        <config07-mensuo v-else-if="deviceTypeJudge('07')"
                         :objData="objData"></config07-mensuo>
        <config013-security v-else-if="deviceTypeJudge('013')"
                            :objData="objData"></config013-security>

        <div v-else>暂时不支持此设备配置场景，请升级软件版本或联系技术人员，谢谢您的支持和理解。</div>
      </div>
      <div v-else-if="type === 'paraconfig'">
        <paraconfig023-f-movies v-if="deviceTypeJudge('023')"
                                :objData="objData"
                                :serve023ShowData="serve023ShowData"></paraconfig023-f-movies>
        <paraconfig014-f-dimming v-else-if="deviceTypeJudge('014', '02')"
                                 :objData="objData"></paraconfig014-f-dimming>
      </div>
      <div v-else>暂时不支持此设备，请升级软件版本或联系技术人员，谢谢您的支持和理解。</div>
    </div>
  </div>
</template>

<script>
import store from "store/index"; ///导入公共仓库
// import vm from '@/main' ///导入VUE实例

import { publicDeviceTypeJudge } from "components/content/contro-view/device-view/device-item-view-js";
////设备控制
import SceneToast from "components/content/control-toast/control-toast-classify/scene-toast";
import Device027SocketW1 from "components/content/control-toast/control-toast-classify/device027-socket-w1";
import Device014FDimming from "components/content/control-toast/control-toast-classify/device014-fdimming";
import Device08AAircond from "components/content/control-toast/control-toast-classify/device08-aircond";
import Device017AFloorheating from "components/content/control-toast/control-toast-classify/device017-a-floorheating";
import Device018ANewtrend from "components/content/control-toast/control-toast-classify/device018-a-newtrend";
import Device024AMusic from "components/content/control-toast/control-toast-classify/device024-a-music";
import Device023FMovies from "components/content/control-toast/control-toast-classify/device023-f-movies";
import Device025FDimming2 from "components/content/control-toast/control-toast-classify/device025-f-dimming2";
import Device026FDimming3 from "components/content/control-toast/control-toast-classify/device026-f-dimming3";
import Device029FRgbw from "components/content/control-toast/control-toast-classify/device029-f-rgbw";
import Device06ADianji from "components/content/control-toast/control-toast-classify/device06-a-dianji";
import Device015A0Dianji from "components/content/control-toast/control-toast-classify/device015-a0-dianji";
import Device020FMianban from "components/content/control-toast/control-toast-classify/device020-f-mianban";
import Device07Mensuo from "components/content/control-toast/control-toast-classify/device07-menSuo";
import Device013Security from "components/content/control-toast/control-toast-classify/device013-security";
import Device022ATiming from "components/content/control-toast/control-toast-classify/device022-a-timing";
import Device019Envprobe from "components/content/control-toast/control-toast-classify/device019-envprobe";
////设备场景配置
import Config027SocketW1 from "components/content/control-toast/config-toast-classify/config027-socket-w1";
import Config014FDimming from "components/content/control-toast/config-toast-classify/config014-fdimming";
import Config08AAircond from "components/content/control-toast/config-toast-classify/config08-aircond";
import Config017AFloorheating from "components/content/control-toast/config-toast-classify/config017-a-floorheating";
import Config018ANewtrend from "components/content/control-toast/config-toast-classify/config018-a-newtrend";
import Config024AMusic from "components/content/control-toast/config-toast-classify/config024-a-music";
import Config023FMovies from "components/content/control-toast/config-toast-classify/config023-f-movies";
import Config025FDimming2 from "components/content/control-toast/config-toast-classify/config025-f-dimming2";
import Config026FDimming3 from "components/content/control-toast/config-toast-classify/config026-f-dimming3";
import Config029FRgbw from "components/content/control-toast/config-toast-classify/config029-f-rgbw";
import Config06ADianji from "components/content/control-toast/config-toast-classify/config06-a-dianji";
import Config015A0Dianji from "components/content/control-toast/config-toast-classify/config015-a0-dianji";
import Config020FMianban from "components/content/control-toast/config-toast-classify/config020-f-mianban";
import Config07Mensuo from "components/content/control-toast/config-toast-classify/config07-menSuo";
import Config013Security from "components/content/control-toast/config-toast-classify/config013-security";

/////设备参数的配置
import Paraconfig023FMovies from "components/content/control-toast/paraconfig-toast-classify/paraconfig023-f-movies";
import Paraconfig014FDimming from "components/content/control-toast/paraconfig-toast-classify/paraconfig014-f-dimming";

export default {
  data () {
    return {
      deviceTemp: "--", ////服务端请求到的温度
      ServeOneObjectinfo: {
        ///服务端请求到的一个对象的设置信息
        businessId1: "",
        businessId1Desc: "",
        businessId2: "",
        businessId2Desc: "",
        businessId3: "",
        businessId3Desc: "",
        businessId4: "",
        businessId4Desc: "",
        buttonCode: "",
        buttonId: 0,
        buttonName: "",
        deleteState: 1,
        deviceId: "",
        deviceName: "",
        deviceNo: 1,
        gatewayId: "",
        gatewayNo: 1,
        iconId: 0,
        iconSuffix: "",
        iconUrl: "",
        list: [],
        passwordState: 0,
        regionId: "",
        regionName: "",
        remark: ""
      },
      serve019ShowData: {
        indoorCO2: "--",
        indoorComfortDegree: "--",
        indoorHumidity: "--",
        indoorPM25: "--",
        indoorTemperature: "--",
        indoorVOC: "--",
        outdoorHumidity: "--",
        outdoorPM25: "--",
        outdoorPollutionDegree: "--",
        outdoorTemperature: "--"
      }, ////服务端请求到的019环境探测数据
      location019: "北京",
      serve023ShowData: [
        {
          keyId: "15",
          moviesKey: 21,
          moviesName: "自定义1"
        },
        {
          keyId: "16",
          moviesKey: 22,
          moviesName: "自定义2"
        },
        {
          keyId: "17",
          moviesKey: 23,
          moviesName: "自定义3"
        },
        {
          keyId: "18",
          moviesKey: 24,
          moviesName: "自定义4"
        },
        {
          keyId: "19",
          moviesKey: 25,
          moviesName: "自定义5"
        },
        {
          keyId: "20",
          moviesKey: 26,
          moviesName: "自定义6"
        },
        {
          keyId: "21",
          moviesKey: 27,
          moviesName: "自定义7"
        },
        {
          keyId: "22",
          moviesKey: 28,
          moviesName: "自定义8"
        },
        {
          keyId: "23",
          moviesKey: 29,
          moviesName: "自定义9"
        }
      ], ////服务端返回的需要展示的数据
      serve027ShowData: {
        ////服务端返回的需要展示的数据

        businessId1: "--",
        businessId1Desc: "",
        businessId2: "--",
        businessId2Desc: "",
        businessId3: "--",
        businessId3Desc: "",
        businessId4: "--",
        businessId4Desc: "",
        businessState1: 0,
        businessState2: 0,
        businessState3: 0,
        businessState4: 0,
        buttonCode: "3",
        buttonId: 0,
        buttonName: "",
        deleteState: 1,
        deviceId: "",
        deviceName: "",
        deviceNo: 1,
        gatewayId: "",
        gatewayNo: 1,
        iconId: 105,
        iconSuffix: "",
        iconUrl: "",
        list: [],
        passwordState: 0,
        productCode: "]",
        productName: "",
        productRemark: "",
        regionId: "",
        regionName: "",
        remark: ""
      }
    };
  },

  components: {
    ///设备控制
    SceneToast,
    Device027SocketW1,
    Device014FDimming,
    Device08AAircond,
    Device017AFloorheating,
    Device018ANewtrend,
    Device024AMusic,
    Device023FMovies,
    Device025FDimming2,
    Device026FDimming3,
    Device029FRgbw,
    Device06ADianji,
    Device015A0Dianji,
    Device020FMianban,
    Device07Mensuo,
    Device013Security,
    Device022ATiming,
    Device019Envprobe,

    ///场景配置
    Config027SocketW1,
    Config014FDimming,
    Config08AAircond,
    Config017AFloorheating,
    Config018ANewtrend,
    Config024AMusic,
    Config023FMovies,
    Config025FDimming2,
    Config026FDimming3,
    Config029FRgbw,
    Config06ADianji,
    Config015A0Dianji,
    Config020FMianban,
    Config07Mensuo,
    Config013Security,

    ///列表参数配置
    Paraconfig023FMovies,
    Paraconfig014FDimming
  },
  methods: {
    backgroundClickHandle () {
      this.$closeControlToast(); ///关闭toast控制弹窗
    },
    deviceTypeJudge (...type) {
      ///判断设备类型
      return publicDeviceTypeJudge(this.objData.productCode, ...type);
    }
  },
  // watch: {
  //   '$store.state.publicinfo.objData': {
  //     handler(newValue, oldValue) {
  //       console.log('当前打开的二级页面数据发生了改变1111')
  //       this.objData = newValue
  //     },
  //     deep: true //深度监听,监听数组的第二层数据变化
  //   }
  // },
  mounted () {
    console.log("控制页面被创建");
    /// 请求设备的当前温度信息接口，获取数据
    if (this.deviceTypeJudge("08", "016", "017", "018")) {
      ///设备包括空调，地暖 新风和环境面板
      ////轻请求接口  获取温度  代号20200709  暂时不需要获取当前温度 去掉了  原因有2 1,大部分都获取不到准确的室内温度2,获取室内温度占用总线空闲时间.
      // this.$lightRequest({
      //   method: "post",
      //   url: "/device/findTemperatureByDeviceId",
      //   data: {
      //     token: store.state.token,
      //     deviceId: this.objData.deviceId
      //   }
      // })
      //   .then(res => {
      //     if (res.data.code != 0) {
      //       // this.$showTipsToast(3, res.data.message);
      //       ////说明信息填写错误,控制失败了，
      //       console.log(res.data);
      //       return;
      //     } else {
      //       ////、控制成功了
      //       this.deviceTemp = res.data.data.temperature; ////拿到服务器返回的温度数据结果
      //       // console.log(res.data);
      //       // this.$store.dispatch("asyUpdataOneSceneRuleList", res.data.data); ////把服务器获取到的规则列表地址存到仓库
      //       // this.$showTipsToast(1, "获取成功", true); ////提示框
      //       //// 提交完服务器的数据到仓库之后在 请求页面跳转。避免出现数据还没请求到，页面已经渲染完的空白页面。
      //       // this.$router.push("ConfigAddSceneRule");
      //     }
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
    } else if (this.deviceTypeJudge("022")) {
      ///设备包括定时控制
      ////轻请求接口  获取设备详情
      this.$lightRequest({
        method: "post",
        url: "/device/findDeviceById",
        data: {
          token: store.state.token,
          deviceId: this.objData.deviceId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            // this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            console.log(res.data);
            return;
          } else {
            ////、控制成功了
            this.ServeOneObjectinfo = res.data.data; ////拿到服务器返回的一个对象的信息
            console.log(this.ServeOneObjectinfo);
            // console.log(res.data);
            // this.$store.dispatch("asyUpdataOneSceneRuleList", res.data.data); ////把服务器获取到的规则列表地址存到仓库
            // this.$showTipsToast(1, "获取成功", true); ////提示框
            //// 提交完服务器的数据到仓库之后在 请求页面跳转。避免出现数据还没请求到，页面已经渲染完的空白页面。
            // this.$router.push("ConfigAddSceneRule");
          }
        })
        .catch(error => {
          console.log(error);
        });
    } else if (this.deviceTypeJudge("019")) {
      // this.location019 = sessionStorage.getItem('positionCity')
      // console.log(this.location019)
      // if (!this.location019) {
      //   this.location019 = '北京'
      // }
      this.location019 = ""; //v2.0.5 版本修改  显示室外环境位环境探测器所在的位置  所以位置需要传空
      console.log(this.location019);

      ///环境探测数据
      ////轻请求接口  获取环境探测器数据
      this.$lightRequest({
        method: "post",
        url: "/device/findDeviceEnvironmentalDetection",
        data: {
          token: store.state.token,
          deviceId: this.objData.deviceId,
          location: this.location019
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            // this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            console.log(res.data);
            return;
          } else {
            ////、控制成功了
            console.log(res.data.data);
            //优化页面显示
            if (res.data.data.indoorCO2 == "") {
              res.data.data.indoorCO2 = "--";
            }
            if (res.data.data.indoorComfortDegree == "") {
              res.data.data.indoorComfortDegree = "--";
            }
            if (res.data.data.indoorHumidity == "") {
              res.data.data.indoorHumidity = "--";
            }
            if (res.data.data.indoorPM25 == "") {
              res.data.data.indoorPM25 = "--";
            }
            if (res.data.data.indoorTemperature == "") {
              res.data.data.indoorTemperature = "--";
            }
            if (res.data.data.indoorVOC == "") {
              res.data.data.indoorVOC = "--";
            }
            if (res.data.data.outdoorHumidity == "") {
              res.data.data.outdoorHumidity = "--";
            }
            if (res.data.data.outdoorPM25 == "") {
              res.data.data.outdoorPM25 = "--";
            }
            if (res.data.data.outdoorPollutionDegree == "") {
              res.data.data.outdoorPollutionDegree = "--";
            }
            if (res.data.data.outdoorTemperature == "") {
              res.data.data.outdoorTemperature = "--";
            }
            this.serve019ShowData = res.data.data; ////拿到服务器返回的一个对象的信息
            // 这样传位置到下一个页面  是为了优化功能，同时减少了代码修改量 ，以及兼容老版本接口报错的问题。后期不要疑惑~
            if (res.data.data.city) {
              this.location019 = res.data.data.city;
            } else {
              this.location019 = "--";
            }

            console.log(this.serve019ShowData);
            // console.log(res.data);
            // this.$store.dispatch("asyUpdataOneSceneRuleList", res.data.data); ////把服务器获取到的规则列表地址存到仓库
            // this.$showTipsToast(1, "获取成功", true); ////提示框
            //// 提交完服务器的数据到仓库之后在 请求页面跳转。避免出现数据还没请求到，页面已经渲染完的空白页面。
            // this.$router.push("ConfigAddSceneRule");
          }
        })
        .catch(error => {
          console.log(error);
        });
    } else if (this.deviceTypeJudge("023")) {
      ////影视设备的
      ///获取影视自定义按键列表 接口，获取数据
      this.$lightRequest({
        method: "post",
        url: "/device/findCustomKeyList",
        data: {
          token: store.state.token,
          deviceId: this.objData.deviceId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            this.serve023ShowData = res.data.data; ////拿到服务器返回的数据结果
            console.log(res.data.data);
            // this.$store.dispatch('asyUpdataconfig019PageData', res.data.data) ///异步提交信息到仓库
            // 跳转页面
            // 对数据进行排序避免显示错乱
            this.serve023ShowData.sort(function (a, b) {
              return a.moviesKey - b.moviesKey;
            });
            console.log(res.data.data);

            // this.$router.go(-1)
            // this.$showTipsToast(1, '设置成功', true) ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    } else if (this.deviceTypeJudge("027")) {
      ////w1插座的
      ///获取设备详情 接口，获取数据
      this.$lightRequest({
        method: "post",
        url: "/device/findDeviceById",
        data: {
          token: store.state.token,
          deviceId: this.objData.deviceId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            this.serve027ShowData = res.data.data; ////拿到服务器返回的数据结果
            console.log(res.data.data);
            // this.$store.dispatch('asyUpdataconfig019PageData', res.data.data) ///异步提交信息到仓库
            // 跳转页面
            // 对数据进行排序避免显示错乱
            // this.serve027ShowData.sort(function(a, b) {
            //   return a.moviesKey - b.moviesKey
            // })

            console.log(res.data.data);

            // this.$router.go(-1)
            // this.$showTipsToast(1, '设置成功', true) ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
    console.log(this.objData);
    ///这里把事件句柄放在了index.js中，这样销毁不会出现问题
    window.addEventListener("control2PageUpdata", this.upadataoneObjData);
    // this.bus.$emit('control2PageUpdata', oneObjData => {
    //   console.log('当前打开的二级页面数据发生了改变')

    //   this.objData = oneObjData
    // })
  },
  destroyed () {
    //监听页面卸载
    console.log("APPcontrol页面卸载");
  }
};
</script>

<style scoped>
.control_wrap {
  position: fixed;
  left: 50%;
  /* 为了适应小屏幕电脑居中稍微往上调一些 */
  top: 46%;
  background: rgba(33, 33, 33, 0.9);
  padding: 20px;
  border-radius: 8px;
  transform: translate(-50%, -50%);
  color: #f5f5f5;
  font-size: 18px;
  /* max-width: 400px; */

  cursor: pointer;

  z-index: 2;
}
</style>
